/**
 * Downsizing's icon: a larger house beside a smaller one (owner, 23 Oct 2026: the falling-chart arrow read as
 * a market fall). Lucide has no "move to a smaller home" icon, so this is drawn in its line style with its
 * factory, and takes the same props as any other Lucide icon.
 */
import { createLucideIcon } from 'lucide-react';

const DownsizeHome = createLucideIcon('DownsizeHome', [
    // The larger home: roof, walls, door.
    ['path', { d: 'M1.5 11 9 4l7.5 7', key: 'big-roof' }],
    ['path', { d: 'M3.5 9.2V21h11V9.2', key: 'big-walls' }],
    ['path', { d: 'M7.5 21v-5h3v5', key: 'big-door' }],
    // The smaller home beside it.
    ['path', { d: 'm15.5 14.5 4-3.5 4 3.5', key: 'small-roof' }],
    ['path', { d: 'M16.5 13.6V21h6v-7.4', key: 'small-walls' }],
    ['path', { d: 'M1 21h22', key: 'ground' }],
]);

export default DownsizeHome;
